import React from "react";
import { Auth } from "aws-amplify";
import { UserContext } from "./withUser";
import Routes from "./Routes/Routes";
import { withRouter } from "react-router-dom";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.handleLogout = async event => {
      await Auth.signOut();
      this.setAuthenticated(false);
    };

    this.setAuthenticated = authenticated => {
      this.setState({ isAuthenticated: authenticated });
      if (!authenticated) this.props.history.push("/");
    };

    this.setUserId = userId => {
      this.setState({ userId });
    };

    this.setIdentityId = identityId => {
      this.setState({ identityId });
    };

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      setAuthenticated: this.setAuthenticated,
      handleLogout: this.handleLogout,
      userId: null,
      identityId: null,
      setUserId: this.setUserId,
      setIdentityId: this.setIdentityId
    };
  }

  async componentDidMount() {
    try {
      const credentials = await Auth.currentCredentials();
      const session = await Auth.currentSession();
      if (session) {
        this.setAuthenticated(true);
        this.setIdentityId(credentials._identityId);
        this.setUserId(session.accessToken.payload.username);
      }
    } catch (e) {
      if (e !== "No current user") {
        console.log(e);
      }
    }

    this.setState({ isAuthenticating: false });
  }

  render() {
    return (
      !this.state.isAuthenticating && (
        <UserContext.Provider value={this.state}>
          <Routes />
        </UserContext.Provider>
      )
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js